<template>

  <div class="col-lg-10 col-lg-offset-1">
    <div class="hpanel">
      <div class="panel-heading">
        Bulk Booking
      </div>
      <div class="panel-body">
        <form @submit.prevent="postBooking()" class="form-horizontal">
          <div class="row">
            <div class="col-md-5" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Organization Name</label>

                <div class=""><input v-model="booking.organization_name" type="text" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-5" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Organization Email</label>

                <div class=""><input v-model="booking.organization_email"  type="text" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Type</label>
                <div class="">
                  <select v-model="booking.booking_type"  class="form-control">
                    <option value="" selected disabled>Select Booking Type</option>
                    <option :value="booking_type.booking_type_public_id" v-for="(booking_type, key) in allGroupBookingTypes" :key="key">{{booking_type.booking_type_name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-5" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Total Guests Numbers</label>
                  <div class=""><input v-model="booking.numbers" disabled type="number" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">EA Adult Citizen(s)</label>
                <div ><input v-model="booking.EaAdultCitizen" type="number" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label"> EA Adult Resident(s)</label>
                <div ><input v-model="booking.AdultResident" type="number" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Non Resident(s)</label>
                <div ><input v-model="booking.NonResident" type="number" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2" style="margin-left: 5%">
              <div class="form-group"><label class="control-label"> EA Citizen Child(s)</label>
                <div ><input v-model="booking.EaCitizenChild" type="number" min="0" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-2" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">EA Child Citizen Resident</label>
                <div ><input v-model="booking.EaChildCitizenResident" type="number" min="0" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-2" style="margin-left: 5%">
              <div class="form-group"><label class="control-label"> Child Non Resident(s)</label>
                <div ><input v-model="booking.ChildNonResident" type="number" min="0" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-2" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Infant(s)</label>
                <div ><input v-model="booking.Infant" type="number" min="0" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label"> 1 - 6 Seater Vehicle</label>
                <div ><input v-model="booking.seater6" type="number" min="0" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">7 - 14 Seater Vehicle</label>
                <div ><input v-model="booking.seater14" type="number" min="0" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label"> 15 and above Seater Vehicle</label>
                <div ><input v-model="booking.seater60" type="number" min="0" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Contact Person's Name</label>

                <div ><input v-model="booking.contact_person_name" type="text" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Contact Person's Email</label>

                <div class=""><input v-model="booking.contact_person_email"  type="email" class="form-control"></div>
              </div>
            </div>
            <div class="col-md-3" style="margin-left: 5%">
              <div class="form-group"><label class="control-label">Contact Person's Phone number</label>

                <div class=""><input v-model="booking.contact_person_phone"  type="tel" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5" style="margin-left: 5%">
              <label class="control-label">Dates</label>
              <div>
                <HotelDatePicker style="margin-left: -3%; width: 225%" :propsData="booking.dates"  @checkInChanged="hmm()"
                >
                </HotelDatePicker>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-5" >
              <div class="form-group">
                <div class="col-sm-8 col-sm-offset-3">
                  <button class="btn btn-primary" type="submit">Make Booking</button>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import HotelDatePicker from 'vue-hotel-datepicker'
export default {
  name: 'GroupBooking',
  data () {
    return {
      booking: {
        seater6: 0,
        seater14: 0,
        seater60: 1,
        booking_type: '',
        numbers: 0,
        email: '',
        phone_number: '',
        organization_name: '',
        organization_email: '',
        contact_person_name: '',
        contact_person_phone: '254',
        contact_person_email: '',
        EaAdultCitizen: 0,
        AdultResident: 0,
        NonResident: 0,
        EaCitizenChild: 0,
        EaChildCitizenResident: 0,
        ChildNonResident: 0,
        Infant: 0
      },
      startDate: '',
      regions: false
    }
  },
  updated () {
    this.booking.numbers = Number(this.booking.EaAdultCitizen) + Number(this.booking.AdultResident) + Number(this.booking.NonResident) + Number(this.booking.EaCitizenChild) + Number(this.booking.EaChildCitizenResident) + Number(this.booking.ChildNonResident) + Number(this.booking.Infant)
  },
  created () {
    this.$store.dispatch('get_group_booking_types')
  },
  methods: {
    hmm: function () {
    },
    getNationality: function () {
      if (this.booking.nationality === 'Other') {
        this.regions = true
      } else {
        this.regions = false
      }
    },
    postBooking: function () {
      var user = {
        user_category: this.user.user_category,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        phone_number: this.user.phone_number
      }
      this.$store.state.userStore.all_users.push(user)
      this.$router.push({
        name: 'AllUsers'
      })
    }
  },
  components: {
    HotelDatePicker
  }
}
</script>

<style>

</style>
